// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-plasterify-container","plaster":"partials-plasterify-plaster","horizontal":"partials-plasterify-horizontal","vertical":"partials-plasterify-vertical"};